"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var BrowserEnvironment = /** @class */ (function () {
    function BrowserEnvironment(window, storage, browserDetectionResult) {
        this.DOMAIN_REGEX = /^(?:https?:\/\/)?(?:[^@/\n]+@)?(?:www\.)?([^:/\n]+)(?:(:\d*)?)/;
        this.window = window;
        this.storage = storage;
        this.browserDetector = browserDetectionResult;
    }
    Object.defineProperty(BrowserEnvironment.prototype, "browserDetails", {
        get: function () {
            var browserName = this.browserDetector.hasOwnProperty('name')
                ? this.browserDetector.name
                : this.window.navigator.appName;
            var osName = this.browserDetector.hasOwnProperty('osname')
                ? this.browserDetector.osname
                : this.window.navigator.platform;
            var version = this.browserDetector.hasOwnProperty('version')
                ? this.browserDetector.version
                : this.window.navigator.appVersion;
            return {
                id: this.storage.get('browserID'),
                name: browserName,
                osName: osName,
                version: version
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserEnvironment.prototype, "currentDomain", {
        get: function () {
            return this.extractDomain(this.currentUrl);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserEnvironment.prototype, "currentPathname", {
        get: function () {
            return this.window.location.pathname;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserEnvironment.prototype, "currentUrl", {
        get: function () {
            return this.window.location.href;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserEnvironment.prototype, "deviceType", {
        get: function () {
            if (!this.browserDetector)
                return null;
            var detectedDeviceType = null;
            if (this.browserDetector.windows ||
                this.browserDetector.mac ||
                this.browserDetector.linux ||
                this.browserDetector.chromeos) {
                detectedDeviceType = 'desktop';
            }
            else if (this.browserDetector.tablet || this.browserDetector.nexusTablet) {
                detectedDeviceType = 'tablet';
            }
            else if (this.browserDetector.mobile ||
                this.browserDetector.nexusMobile ||
                this.browserDetector.windowsphone) {
                detectedDeviceType = 'mobile';
            }
            else if (this.browserDetector.xbox || this.browserDetector.playstation) {
                detectedDeviceType = 'console';
            }
            return detectedDeviceType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserEnvironment.prototype, "locales", {
        get: function () {
            try {
                if (this.window.navigator.hasOwnProperty('languages')) {
                    return __spreadArray([], this.window.navigator.languages, true).map(function (l) { return l.toLowerCase(); });
                }
                else {
                    return [this.window.navigator.language].map(function (l) { return l.toLowerCase(); });
                }
            }
            catch (err) {
                return [];
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserEnvironment.prototype, "referrerDomain", {
        get: function () {
            return this.extractDomain(this.referrerUrl);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserEnvironment.prototype, "referrerUrl", {
        get: function () {
            return this.window.document.referrer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserEnvironment.prototype, "screenResolution", {
        get: function () {
            return {
                height: this.window.screen.availHeight,
                width: this.window.screen.availWidth
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserEnvironment.prototype, "snapshot", {
        get: function () {
            return {
                browser: {
                    id: this.browserDetails.id,
                    name: this.browserDetails.name,
                    osName: this.browserDetails.osName,
                    version: this.browserDetails.version
                },
                deviceType: this.deviceType,
                locales: this.locales,
                resolution: this.screenResolution,
                timeOffset: new Date().getTimezoneOffset(),
                url: {
                    current: this.currentUrl,
                    referrer: this.referrerUrl
                },
                userAgent: this.userAgent
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserEnvironment.prototype, "urlQueryParams", {
        get: function () {
            var query = decodeURIComponent(this.window.location.search);
            if (query.startsWith('?'))
                query = query.slice(1);
            var params = {};
            query.split('&').forEach(function (q) {
                var key = q.split('=')[0];
                var value = q.split('=')[1];
                params[key] = value;
            });
            return params;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserEnvironment.prototype, "userAgent", {
        get: function () {
            return this.window.navigator.userAgent;
        },
        enumerable: false,
        configurable: true
    });
    BrowserEnvironment.prototype.extractDomain = function (url) {
        var regexRes = this.DOMAIN_REGEX.exec(url);
        if (regexRes === null || regexRes.length < 2)
            return '';
        return regexRes[1].toLowerCase();
    };
    return BrowserEnvironment;
}());
exports.default = BrowserEnvironment;
//# sourceMappingURL=data:application/json;base64,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